<template>
  <div id="Extension" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 bg-color-primary pl5 pr5 fixed-t b-s-2 pb10">
      <div class="col-12 lh40 bg-color-primary pl5 pr5">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-white"></i></div>
          <div class="col-6 t-c color-white el1">{{posData.enterprise_name}}</div>
          <div class="col-3 t-r f26"></div>
      </div>
      
      <div class="col-12 pl10 pr10 color-white">
      <div class="col-12 r5 p5">
          <div class="col-2 f40 color-white t-c"><i class="iconfont icon-diannao"></i></div>
          <div class="col-9 pl10 f16 t-l pt10">
              <div class="col-12 uppercase mb5"><span class="fw">{{pageData.extension_name}}</span> </div>
              <div class="col-12 f12">{{ pageData.update_time }}</div>
          </div>
          <div class="col-1 t-r lh50"></div>
      </div>
    </div>
    </div>
    <div class="h12"></div>
    <div class="col-12 bg-color-white pl8 pr8 color-muted f14">
      <div class="col-12 bb1 pt10 pb10" v-if="hardInfo">
        <div class="col-4">Plataforma</div>
        <div class="col-8 t-r">{{ hardInfo.windows}}</div>
      </div>
      <div class="col-12 bb1 pt10 pb10" v-if="hardInfo">
        <div class="col-4">Procesador</div>
        <div class="col-8 t-r">{{ hardInfo.cpu}}</div>
      </div>
      <div class="col-12 bb1 pt10 pb10" v-if="hardInfo">
        <div class="col-4">Memoria</div>
        <div class="col-8 t-r">{{ hardInfo.ram}}</div>
      </div>
      <div class="col-12 bb1 pt10 pb10" v-if="hardInfo">
        <div class="col-4">Idioma</div>
        <div class="col-8 t-r">
          <span v-if="hardInfo.os_lang == 3082">Español [es-ES]</span>
          <span v-else-if="hardInfo.os_lang == 2052">Chino [zh-CN]</span>
          <span v-else-if="hardInfo.os_lang == 1033">English [en-US]</span>
        </div>
      </div>
      <div class="col-12 bb1 pt10 pb10">
        <div class="col-4">POS Versión</div>
        <div class="col-8 t-r">{{ pageData.pos_ver}}</div>
      </div>
      <div class="col-12 bb1 pt10 pb10">
        <div class="col-4">Instalar</div>
        <div class="col-8 t-r"><span v-if="pageData.re_install">Permitir</span><span v-else>No permitido</span></div>
      </div>
      <div class="col-12 bb1 pt10 pb10" v-if="pageData.pos_install_password && pageData.tec_id == $store.state.account.account_id">
        <div class="col-4">Contraseña del técnico</div>
        <div class="col-8 t-r uppercase">{{pageData.pos_install_password}}</div>
      </div>
      <div class="col-12 bb1 pt10 pb10">
        <div class="col-4">Vencimiento</div>
        <div class="col-8 t-r"><span :class="[pageData.exp_day <= 0?'color-danger':'color-muted']">{{ pageData.exp_day}}</span> días</div>
      </div>
    </div>
    <div ref="app_foot" class="col-12 fixed-b color-white f14 bg-color1 lh50 h5 uppercase">
      <div class="col-12 bg-color-primary t-c f12" @click="act_confim('go_reinstall')"><i class="iconfont icon-zhuomianruanjiananzhuangshenqing color-white f22"></i> Reinstalar</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Extension',
  data () {
    return {
      extid: '',
      posData: {},
      pageData: {},
      hardInfo:{}
    }
  },
  created: function () {
    this.extid = this.$route.query.extid;
    this.get_pageData();
  },
  methods: {
    get_pageData() {
      var post_data = {}
      post_data.extid = this.extid
      this.post(this.api_url + 'Agent/extension',post_data,true).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data; 
          this.posData = res.data.pos;
          this.hardInfo = res.data.hardinfo;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    act_confim(method){
      this.$store.commit('setConfimBox',{type:'confim_exit',msg:'¿Estás seguro de continuar?',_this:this,focus:'',method:method,arg1:''});
    },
    /*
    go_renew() {
      var post_data = {};
      post_data.extid = this.pageData.extid;
      this.post(this.api_url + 'Agent/renew_now',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.get_pageData();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    */
    go_reinstall() {
      var post_data = {};
      post_data.extid = this.pageData.extid;
      this.post(this.api_url + 'Agent/reinstall_now',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.get_pageData();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    /*
    go_del(){
      var post_data = {};
      post_data.extid = this.pageData.extid;
      this.post(this.api_url + 'Agent/de_activation',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.$router.back(-1);
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    }
    */
  },
  watch: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Agent/Extension.vue